export enum ValidationState {
    WAITING = 'waiting',
    LOADING = 'loading',
    FREE = 'free',
    TAKEN = 'taken',
    NOT_ALLOWED = 'not_allowed',
    ERROR = 'error',
}
